import useProfile from "common/hooks/useProfile";
import { RootState } from "common/redux/core/root.reducer";
import { useSelector } from "react-redux";
import { ButtonType } from "common/enums";
import { Button } from "common/components";
import useCustomTranslation from "common/hooks/useCustomTranslation";
import labelCollection from "../../config/langauge-keys.config";

import "./Welcome.scss";

type WelcomeProps = {
  onClick: () => void;
};

const Welcome = ({ onClick }: WelcomeProps) => {
  const { isReadOnlyUser, isSuperAdmin } = useSelector(
    (state: RootState) => state.user
  );
  const { t } = useCustomTranslation(["home"]);

  const { displayName } = useProfile();

  const firstName = displayName.split(" ")[0];

  return (
    <div className="welcome">
      <div className="welcome__container">
        <p className="welcome__container--heading">
          {t(labelCollection.cardWelcome)}, <span>{firstName}</span>
        </p>
        <div
          className={`content-box ${
            isSuperAdmin ? "content-box--super-admin" : ""
          }`}
        >
          {isSuperAdmin && (
            <div className="super-admin">
              <p className="no-client-heading">
                {t(labelCollection.noClientsSystem)}
              </p>
              <p className="no-client-desc">
                {t(labelCollection.noClientsSystemDesc)}
              </p>
              <Button type={ButtonType.BUTTON} size="small" onClick={onClick}>
                {t(labelCollection.addClientBtn)}
              </Button>
            </div>
          )}
          {isReadOnlyUser ||
            (!isSuperAdmin && !isReadOnlyUser && (
              <div className="user">
                <p className="no-client-heading">
                  {t(labelCollection.noClientsList)}
                </p>
                <p className="no-client-desc">
                  {t(labelCollection.noClientsListDesc)}
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
